import { styled } from 'linaria/react';
import { css } from 'linaria';
import { media } from '../../../../../media';

export const SwiperWrapper = styled.div`
	position: relative;
`;

export const SwiperContainer = css`
	position: initial;
	box-sizing: content-box;
	width: 100%;
	padding: 0 10px 32px;
	margin-left: -10px;
	overflow: hidden;
	${media.laptop} {
		overflow: visible;
	}

	& .swiper-wrapper {
		display: flex;
		margin-top: 40px;
		${media.tablet} {
			margin-top: 44px;
		}
		${media.mobile} {
			margin-top: 28px;
		}
	}
`;

export const CommonButtonStyles = css`
	position: absolute;
	top: 49%;
	z-index: 3;
	${media.laptop} {
		display: none;
	}

	&.swiper-button-disabled {
		display: none;
	}
`;

export const ButtonPrevStyle = css`
	left: -5px;
	transform: translateX(-50%);
`;

export const ButtonNextStyle = css`
	right: 19px;
	transform: translateX(90%);
`;

export const PopularCategoryCardRegion = css`
	grid-template-rows: 183px 1fr !important;
	width: 372px !important;
	height: 416px !important;
	${media.laptop} {
		width: 280px !important;
	}
	${media.mobile} {
		width: 263px !important;
	}
`;

export const PopularCategoryCardMoscow = css`
	grid-template-rows: 183px 1fr !important;
	width: 280px !important;
	height: 384px !important;
	${media.mobile} {
		width: 258px !important;
	}
`;

// !important чтобы перебить стили, которые идут с компонентом CategoryCard
// (стили отличаются в зависимости от расположения - в популярных услугах/каталоге)
